"use strict";

import angular from "angular";

export class ToastRecommendationService {
    constructor($rootScope) {
        this.$rootScope = $rootScope;
        this.toggleCallbacks = [];
        this.openCallbacks = [];
        this.closeCallbacks = [];
    }

    toggle() {
        this.toggleCallbacks.forEach((cb) => cb());
    }

    open() {
        this.openCallbacks.forEach((cb) => cb());
    }

    close() {
        this.closeCallbacks.forEach((cb) => cb());
    }

    onToggle(callback) {
        this.toggleCallbacks.push(callback);
    }

    onOpen(callback) {
        this.openCallbacks.push(callback);
    }

    onClose(callback) {
        this.closeCallbacks.push(callback);
    }
}

ToastRecommendationService.$inject = ["$rootScope"];

angular.module("nucont.shared")
    .service("ToastRecommendationService", ToastRecommendationService);
